var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRounddesign(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 233,
    viewBox: "0 0 233 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.996 115.499C232.448 51.1599 179.848 -0.548641 115.509 0.0043951C51.1704 0.557432 -0.542897 53.1626 0.00430285 117.501C0.551503 181.84 53.152 233.549 117.491 232.996C181.83 232.443 233.543 179.837 232.996 115.499ZM177.596 115.295C177.301 80.6642 149.138 52.8309 114.69 53.127C80.2434 53.423 52.5573 81.7365 52.8518 116.367C53.1463 150.997 81.31 178.83 115.757 178.534C150.204 178.238 177.89 149.925 177.596 115.295Z",
    fill: "#FF6000",
    fillOpacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRounddesign);
export default __webpack_public_path__ + "static/media/rounddesign.fc666fd094d1640e591d81970f4865d9.svg";
export { ForwardRef as ReactComponent };